import { TableCell, TableRow } from "@mui/material";
import { GlobalClassKeys } from "assets/jss/common-styles";
import IconCreatePublication from "components/Icons/IconCreatePublication";
import { JoinComponents } from "components/JoinComponents";
import MuiLink from "components/MuiExtras/MuiLink";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import { TextPluralization } from "components/TextPluralization";
import { Formaters } from "lib/Formarters";
import { PublicationType } from "models/ApiEnums";
import { DashboardPublicationModel } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { getPublicationUrl } from "views/Timeline/Components/FeedHelpers";

/////////////////////////////////////////////////////////////////////////////////////

export interface RenderPublicationModelListEvents {
    onSelectPublication?: (publicationId: string, title: string, thumbnailUrl: string) => void;
}

interface IRenderPublicationModelListProps {
    indexOffset: number;
    items: DashboardPublicationModel[];
    answersFromUserId?: string;
    detailCountText?: {
        singular: string;
        plural: string;
    };
    showDrillColumn?: boolean;
    showCreationDate?: boolean;
    showTopicName?: boolean;
    onDrillDown?: (item: DashboardPublicationModel) => void;
}

export const RenderPublicationModelList: React.FC<IRenderPublicationModelListProps & RenderPublicationModelListEvents> = (props) => {
    const { t } = useTranslation();

    return (
        <>
            {
                props.items.map((v, index) => {
                    let url: string = null;
                    let target: string = null;

                    if (props.onSelectPublication == null) {
                        target = "_blank";
                        url = getPublicationUrl(v.publicationId, v.publicationType);

                        if (v.publicationType == PublicationType.Question && props.answersFromUserId)
                            url += "?afu=" + props.answersFromUserId;
                    }

                    const detailLine = [];


                    if (v.creationDate && props.showCreationDate)
                        detailLine.push(<span>{Formaters.relativeTime(v.creationDate)}</span>);
                    if (v.detailCount != null)
                        detailLine.push(
                            <>
                                <span>{v.detailCount}&nbsp;</span>
                                {props.detailCountText && <TextPluralization count={v.detailCount} {...props.detailCountText} />}
                            </>
                        );

                    return (
                        <TableRow key={index}>
                            <TableCell style={{ width: 1, verticalAlign: "top" }} className={GlobalClassKeys.bold}>
                                {props.indexOffset + index + 1}
                            </TableCell>

                            <TableCell style={{ width: 1 }}>
                                <MuiLink href={url} target="_blank">
                                    {
                                        v.thumbnailUrl
                                            ? <img src={v.thumbnailUrl} alt={v.title} style={{ maxWidth: 64 }}  />
                                            : <IconCreatePublication size="3x" color="muted"/>
                                    }
                                </MuiLink>
                            </TableCell>

                            <TableCell style={{ verticalAlign: "top" }}>
                                {
                                    url != null
                                        ? (
                                            <MuiLink
                                                color="secondary"
                                                href={url}
                                                target={target}
                                            >
                                                {v.publicationType == PublicationType.Answer && <s>{t("Common.Literals.AnswerText")}: </s>}
                                                {v.title}
                                            </MuiLink>
                                        )
                                        : props.onSelectPublication != null
                                            ? (
                                                <MuiLink
                                                    color="secondary"
                                                    target={target}
                                                    onClick={() => props.onSelectPublication(v.publicationId, v.title, v.thumbnailUrl)}
                                                >
                                                    {v.publicationType == PublicationType.Answer && <s>{t("Common.Literals.AnswerText")}: </s>}
                                                    {v.title}
                                                </MuiLink>
                                            )
                                            : <b>{v.title}</b>
                                }

                                <MuiMuted>
                                    <small>
                                        {
                                            props.showTopicName && v.firstTopicName &&
                                            <div>{v.firstTopicName}</div>
                                        }
                                   
                                        <div>
                                            <JoinComponents components={detailLine} />
                                        </div>
                                    </small>
                                </MuiMuted>
                            </TableCell>

                            {
                                v.total != null && props.showDrillColumn &&
                                <TableCell align="right" style={{ verticalAlign: "top"}}>
                                    {
                                        props.onDrillDown
                                            ? <MuiLink color="secondary" onClick={() => props.onDrillDown(v)}>{v.total.toLocaleString()}</MuiLink>
                                            : v.total
                                    }
                                </TableCell>
                            }

                        </TableRow>
                    );
                })
            }
        </>
    );
};

RenderPublicationModelList.defaultProps = {
    showCreationDate: true,
    showTopicName: true,
    showDrillColumn: true
};
/////////////////////////////////////////////////////////////////////////////////////
